export enum UserInvoiceTypes {
  GET_INVOICES_SUCCESS = 'GET_USER_INVOICES_SUCCESS',
  GET_INVOICES_FAILURE = 'GET_USER_INVOICES_FAILURE',
}
